export default class NotificationHistoryQuery {

    public static GetNotificationHistory = `query GetNotificationHistoryQuery($projectId: String) {
        getNotificationHistory (
            projectId:$projectId
        ) {
            id
            pushNotificationBody
            pushNotificationDate
            pushNotificationTime
            appTargetType
            appTargetSelection
            numberOfDevices
            numberOpened
            completed
            date
            projectId
        }      
    }`;

    public static CreateNotificationHistory = `mutation CreateNotificationHistoryQuery($input: NotificationHistoryInput!) {
        createNotificationHistory(input: $input) {
            id
            pushNotificationBody
            pushNotificationDate
            pushNotificationTime
            appTargetType
            appTargetSelection
            numberOfDevices
            numberOpened
            completed
            date
            projectId
        }
    }`;

    public static DeleteNotificationHistory = `mutation DeleteNotificationHistoryQuery($id: ID!) {
        deleteNotificationHistory(id: $id) {
            id
        }
    }`;
}